import React from 'react';
import css from '../styles/area-probate.css';

const { Component } = React;

class AreaProbate extends Component {
  render() {
    return (
      <div className="areas-area__wrapper areas-area__wrapper--hero areas-area__wrapper--probate">
        <div class="areas-area__hero-text" data-aos="zoom-in">
          <h3>Probate and Ancillary Probate</h3>
          <p>I can assist you with probate matters in Oklahoma, whether general or ancillary.  The process of probating a will or an intestate estate is complex and requires an experienced attorney to ensure that all notices and publications have been timely and properly given, all inventories and accountings are properly prepared and filed, and all claims evaluated and allowed or denied.  I can guide and represent you through this process.</p>
        </div>
        <div class="areas-area__hero">
        </div>
      </div>
    );
  }
}

export { AreaProbate };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/area-probate.js